import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import * as styles from './OnBoardingDelete.css';
import { Button, ArticleHeading2, UIText2 } from '@cian/ui-kit';
import { OnBoarding } from '../OnBoarding';
import { AnimationFade } from '../AnimationFade';
import { getOnBoardingDeleteVisible, hideOnBoardingDeleteVisible } from '../../utils/localStorage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function OnBoardingDelete(_ref) {
  var visible = _ref.visible;
  var _React$useState = React.useState(getOnBoardingDeleteVisible()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    show = _React$useState2[0],
    setShow = _React$useState2[1];
  var handleClose = function handleClose() {
    hideOnBoardingDeleteVisible();
    setShow(false);
  };
  return /*#__PURE__*/_jsx(AnimationFade, {
    show: visible && show,
    children: /*#__PURE__*/_jsxs(OnBoarding, {
      onClose: handleClose,
      children: [/*#__PURE__*/_jsx("header", {
        className: styles['header'],
        children: /*#__PURE__*/_jsx("div", {
          className: styles['heart']
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles['body'],
        children: [/*#__PURE__*/_jsx(ArticleHeading2, {
          children: "\u0423\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E"
        }), /*#__PURE__*/_jsx(UIText2, {
          children: "\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u043E \u0438\u0437 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0438 \u0432\u0441\u0435\u0445 \u043F\u043E\u0434\u0431\u043E\u0440\u043E\u043A"
        }), /*#__PURE__*/_jsx(Button, {
          fullWidth: true,
          size: "XS",
          onClick: handleClose,
          children: "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"
        })]
      })]
    })
  });
}